import { motion } from "framer-motion";

const ProjectCard = ({ title, description, images, tags, link }) => {
    return (
        <motion.div
            whileHover={{ y: -5 }}
            className="bg-white/5 backdrop-blur rounded-2xl overflow-hidden border border-white/10 w-[350px]"
        >
            {/* IMAGE GRID */}
            <div className="grid grid-cols-2 grid-rows-2 h-[200px] gap-[2px]">
                {images.slice(0, 4).map((img, index) => (
                    <img
                        key={index}
                        src={img}
                        alt={title}
                        className="w-full h-full object-cover"
                    />
                ))}
            </div>

            {/* CONTENT */}
            <div className="p-4">
                <h3 className="text-lg font-semibold">{title}</h3>
                <p className="text-sm opacity-80 mt-1">{description}</p>

                {/* TAGS */}
                <div className="flex flex-wrap gap-2 mt-3">
                    {tags.map((tag) => (
                        <span
                            key={tag}
                            className="text-xs px-2 py-1 rounded-full bg-white/10"
                        >
                            {tag}
                        </span>
                    ))}
                </div>

                {/* LINK */}
                {link && (
                    <a
                        href={link}
                        target="_blank"
                        className="inline-block mt-4 text-sm text-blue-400 hover:underline"
                    >
                        View project →
                    </a>
                )}
            </div>
        </motion.div>
    );
};

export default ProjectCard;
